import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Chevron = ({
  className,
  color = '#00304D',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.59003 16.59L13.17 12L8.59003 7.41L10 6L16 12L10 18L8.59003 16.59Z"
        fill={color}
      />
    </svg>
  );
};
